export default {
  deviceSettings: {
    branchId: 'Filialien ID',
    companyKey: 'Unternehmensschlüssel',
    deviceId: 'Geräte-ID',
    headingRegister: 'Gerät registrieren',
    headingUpdate: 'Einstellungen Passcode ändern',
    invalidDeviceReference: 'Ihr Gerät wurde möglicherweise von Ihrem Administrator deaktiviert.',
    passcode: 'Passcode',
    pleaseWaitRegister: 'Bitte warten Sie, während wir Ihr Gerät registrieren',
    pleaseWaitUpdate: 'Bitte warten Sie, während wir Ihr Gerät aktualisieren',
    registrationFailed: 'Geräteregistrierung fehlgeschlagen',
    settingsPasscode: 'Einstellungen-Passcode',
    newSettingsPasscode: 'Neue Einstellungen Passcode',
    settingsPasscodeConfirm: 'Einstellungen-Passcode bestätigen',
    successRegister: 'Erfolg. Ihr Gerät wurde registriert!',
    successUpdate: 'Erfolg. Ihr Gerät wurde aktualisiert!',
    updateFailed: 'Geräteaktualisierung fehlgeschlagen'
  }
};